import { CatalogItemViewClientOwnViewModel } from '@common/model/catalog/item/catalogItemView';
import { coreCurrentClientApi } from '../../api';
import { useIsLoggedIn } from '../../../currentUser';

export const useClientOwnCatalogItemViews = (): CatalogItemViewClientOwnViewModel[] => {
  const isLoggedIn = useIsLoggedIn();
  const { data } = coreCurrentClientApi.endpoints.getOwnCatalogItemViews.useQuery(undefined, { skip: !isLoggedIn });
  return data ?? [];
};
